module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAKCAYAAABrGwT5AAAAAXNSR0IArs4c6QAAAONJREFUKFOV0ssqBlAUxfHfnpu4JHdFhiZGMlBS8iS8j3fwDKZmGKJcEklRDFxiZLK1dejDpziTU3vvtVvrf07458nMEWxiLf6jzcwxbGO67j+LM3MQO5jCMVYiM4ewgfWIeOjmpM3sYhLnWIyImxJvYRUHrfjUuSAz+3GIYZxiOSKua6bEMy1HgajmfEQ8VjMzB7CP6h1hKSLuPpa/Z87MylEgxnGBWfTiBD2tthARt52uPoE1kpVrFFfoa8Kz5ub+O48vtDNzAnsoiHUuy0VEvHQD+eOpGtla8Iy5iHj97S+8ARnjTAKFJ68TAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-v2/Check.png
// module id = WFY8
// module chunks = 44